import React from 'react';

import {Atom, withSystem, Types} from '@packages/systems/wfdl';
import {emptyObject} from '@packages/utilities/fp/utils';
import {
  USYS_DOM_CLASS_NAMES,
  USYS_DATA_ATTRS,
} from '@packages/systems/users/constants';
import {
  UsysUtilityPageConstraint,
  setDisplayBlock,
  extraAtomFields,
} from '../utils';
import {TListOfElement, TRecord, TText} from '@packages/systems/wfdl-ast';
import {defaultIntegratedTypes} from '@packages/utilities/integrated-types';
import {EvaluatedNodeData, getChildren} from '@packages/utilities/data-utils';

const UserSignUpVerificationMessage = Atom.createRender(
  ({attributes, classes, generateAttributes, context, data, renderChild}) => {
    const verificationClasses = classes.push(
      USYS_DOM_CLASS_NAMES.formVerfication
    );
    const props = generateAttributes(attributes, verificationClasses);
    const finalProps =
      context.get('formStatus') === 'verification'
        ? {
            ...props,
            style: setDisplayBlock(props.style || emptyObject),
          }
        : props;

    return (
      <div {...finalProps} {...{[USYS_DATA_ATTRS.formVerification]: true}}>
        {getChildren(data).map((child: EvaluatedNodeData) =>
          renderChild(child)
        )}
      </div>
    );
  }
);

const config = Atom.create({
  displayName: 'Sign Up Verification',
  showEmpty: true,
  constraints: {
    pinToParent: true,
    ancestors: [{is: 'UserSignUpFormWrapper', rule: 'ExactlyOne'}],
    page: [UsysUtilityPageConstraint],
  },
  lockedStyles: {
    display: {
      when: true,
      message:
        'The display setting can’t be changed for a form’s verification message.',
    },
  },
  render: UserSignUpVerificationMessage,
  dataType: withSystem(
    {private: true},
    TRecord(
      Types.deepMergeTypes(defaultIntegratedTypes, {
        attr: TRecord({
          // tabIndex is required to focus a normally non-iterative element
          tabIndex: withSystem({defaultValue: '-1'}, TText),
        }),
        children: TListOfElement,
      }),
      extraAtomFields
    )
  ),
  style: {
    base: {
      main: {
        noPseudo: {
          display: 'none',
        },
      },
    },
  },
});

export default config;
